// extracted by mini-css-extract-plugin
module.exports = {"notFound":"not-found-page_notFound__S_RMV","info":"not-found-page_info__9uzyO"};